import FilterConstants from '../../../../filter-constants';
import * as CircuitUtils from '../../../utils/circuit';

export function computeCapacitorLimitMultipliers(c1IdealValue, r1IdealValue) {
  let maxMultiplier = computeCapacitorMaximumLimitMultiplier(c1IdealValue, r1IdealValue);
  let minMultiplier = computeCapacitorMinimumLimitMultiplier(c1IdealValue, r1IdealValue);
  return {
    capacitorMinimumLimitMultiplier: minMultiplier,
    capacitorMaximumLimitMultiplier: maxMultiplier,
  };
}

export function computeGainResistorLimitMultipliers(r3IdealValue, r4IdealValue) {
  let minMultiplier = CircuitUtils.getResistorMinimumLimitMultiplier(r3IdealValue, r4IdealValue);
  let maxMultiplier = CircuitUtils.getResistorMaximumLimitMultiplier(r3IdealValue, r4IdealValue);
  return {
    resistorMinimumLimitMultiplier: minMultiplier,
    resistorMaximumLimitMultiplier: maxMultiplier,
  };
}

function computeCapacitorMaximumLimitMultiplier(c1IdealValue, r1IdealValue) {
  var result = FilterConstants.Limits.CBIG_COMP_LIMIT / c1IdealValue;
  var r1Tiny = r1IdealValue / result;

  if (r1Tiny < FilterConstants.Limits.RSMALL_LOAD_LIMIT) {
    result = (result * r1Tiny) / FilterConstants.Limits.RSMALL_LOAD_LIMIT;
  }

  return result;
}

function computeCapacitorMinimumLimitMultiplier(c1IdealValue, r1IdealValue) {
  var result = FilterConstants.Limits.CSMALL_COMP_LIMIT / c1IdealValue;
  var r1Big = r1IdealValue / result;

  if (r1Big > FilterConstants.Limits.RBIG_COMP_LIMIT) {
    result = (result * r1Big) / FilterConstants.Limits.RBIG_COMP_LIMIT;
  }

  return result;
}
